function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export const AppContext = /*#__PURE__*/React.createContext({
  state: null,
  apis: null,
  logonApis: null,
  auth: null,
  urlResolver: null,
  projectName: null
});
export const useAppContext = () => React.useContext(AppContext);
export const useUrlResolver = () => {
  const {
    urlResolver
  } = useAppContext();
  return urlResolver;
};
export const useAppUrl = attr => {
  const urlResolver = useUrlResolver();
  return urlResolver.getUrl(attr);
};
export const useAppUser = () => {
  const {
    state
  } = useAppContext();
  return state.auth.user;
};
export const withAppContext = Component => props => /*#__PURE__*/React.createElement(AppContext.Consumer, null, context => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  app: context,
  appContext: context
})));
export const withAppState = Component => props => /*#__PURE__*/React.createElement(AppContext.Consumer, null, context => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  appState: context.state
}))); // @duplicated

export const withAppUserPreferences = Component => props => /*#__PURE__*/React.createElement(AppContext.Consumer, null, context => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  appUser: context.state.auth,
  authUser: context.state.auth
})));
export const withAppUser = Component => props => /*#__PURE__*/React.createElement(AppContext.Consumer, null, context => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  appUser: context.state.auth.user,
  authUser: context.state.auth.user
})));
export const withAppApis = Component => props => /*#__PURE__*/React.createElement(AppContext.Consumer, null, context => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  appApis: context.apis
})));
export const withLogonApis = Component => props => /*#__PURE__*/React.createElement(AppContext.Consumer, null, context => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  logonApis: context.logonApis
})));
export const withUrlResolver = Component => props => /*#__PURE__*/React.createElement(AppContext.Consumer, null, context => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  urlResolver: context.urlResolver
})));
export default AppContext;